import api from '../../api/facilityGroup.api';

export function findFacilityGroupsByTitle(title) {
  return () => {
    const query = `${title ? `title=${title}`: ''}`;
    return api.fetchFacilityGroups(query)
        .then(response => response.result)
        .catch(error => Promise.reject(error));
  };
}